var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFaqSuspension = function SvgFaqSuspension(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 10 26"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#faq-suspension_svg__a)",
    fillRule: "evenodd",
    d: "M9.738 4.871c0-.897-.73-1.627-1.626-1.627h-.939V2.056c0-.897-.73-1.627-1.627-1.627H4.4c-.897 0-1.627.73-1.627 1.627v1.188h-.938c-.897 0-1.627.73-1.627 1.627v1.93l9.521-1.46v-.47z",
    clipRule: "evenodd",
    opacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#faq-suspension_svg__b)",
    fillRule: "evenodd",
    d: "M1.438 10.93c.052 0 .104 0 .167-.01l7.07-1.106c.563-.083.96-.625.866-1.189a1.03 1.03 0 0 0-1.189-.865l-7.07 1.105c-.563.084-.96.626-.866 1.19.084.51.522.885 1.033.885z",
    clipRule: "evenodd",
    opacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#faq-suspension_svg__c)",
    fillRule: "evenodd",
    d: "M8.915 14.017c.564-.084.96-.626.866-1.189a1.03 1.03 0 0 0-1.189-.865l-7.07 1.105c-.563.083-.96.626-.866 1.189.084.51.522.886 1.033.886.052 0 .104 0 .167-.01l1.21-.188v2.69a4.26 4.26 0 0 0-2.107 3.66 4.275 4.275 0 0 0 4.275 4.276 4.27 4.27 0 0 0 4.276-4.275c0-1.565-.845-2.92-2.107-3.66v-3.369l1.533-.24zM7.78 21.285a2.564 2.564 0 0 1-2.566 2.566 2.564 2.564 0 0 1-2.565-2.566 2.563 2.563 0 0 1 2.565-2.565 2.563 2.563 0 0 1 2.566 2.565",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "faq-suspension_svg__a",
    x1: 4.973,
    x2: 4.973,
    y1: 6.8,
    y2: 0.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#00CDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01DCCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "faq-suspension_svg__b",
    x1: 4.978,
    x2: 4.978,
    y1: 10.941,
    y2: 7.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#00CDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01DCCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "faq-suspension_svg__c",
    x1: 5.219,
    x2: 5.219,
    y1: 25.571,
    y2: 11.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#00CDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01DCCF"
  })))));
};
export default SvgFaqSuspension;